<template>
  <TableLayout :permissions="['meihui:templateConfig:query']">
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
      <el-form-item label="名称"><el-input v-model="searchForm.templateName" placeholder="名称" @keypress.enter.native="search" /></el-form-item>
      <section><el-button type="primary" @click="search">搜索</el-button><el-button @click="reset">重置</el-button></section>
    </el-form>
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.opera.open('新建模板配置')" icon="el-icon-plus" v-permissions="['meihui:templateConfig:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['meihui:templateConfig:delete']">批量删除</el-button></li>
      </ul>
      <el-table v-loading="isWorking.search" :data="tableData.list" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="id" label="ID" width="80" show-overflow-tooltip />
        <el-table-column prop="templateName" label="名称" width="150" show-overflow-tooltip />
        <el-table-column prop="templateType" label="类型" width="150" show-overflow-tooltip />
        <el-table-column prop="isDefault" label="默认" width="80" show-overflow-tooltip />
        <el-table-column prop="isActive" label="启用" width="80" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.opera.open('编辑模板配置', row)" icon="el-icon-edit" v-permissions="['meihui:templateConfig:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['meihui:templateConfig:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination @size-change="handleSizeChange" @current-change="handlePageChange" :pagination="tableData.pagination" />
    </template>
    <operatemplateConfigWindow ref="opera" @success="handlePageChange" />
  </TableLayout>
</template>
<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import operatemplateConfigWindow from './operatemplateConfigWindow'
export default {
  name: 'TemplateConfig', extends: BaseTable, components: { TableLayout, Pagination, operatemplateConfigWindow },
  data() { return { searchForm: {} } },
  created() {
    this.config({ module: '模板配置', api: '/rentHouse/templateConfig', 'field.id': 'id', 'field.main': 'templateName' })
    this.search()
  }
}
</script>